import { useSelector } from 'react-redux';
import { GeneralEnterpriseSubscriptionTier, GeneralSubscription } from '@mews-commander/data-access';
import { Card } from '@optimus-web/core';
import { SmallContentContainer } from '@mews-commander/ui';
import { getCurrentEnterpriseSubscription } from '@mews-commander/legacy-entities/src/selectors/session/subscription';
import { CheckInFieldsContainer } from './CheckInFieldsContainer/CheckInFieldsContainer';
import { UpgradeContent } from './UpgradeContent';

interface CheckInFieldsContentProps {
    enterpriseId: string;
}

export const CheckInFieldsContent = ({ enterpriseId }: CheckInFieldsContentProps) => {
    const { tier }: GeneralSubscription = useSelector(getCurrentEnterpriseSubscription);

    if (tier === GeneralEnterpriseSubscriptionTier.Basic) {
        return (
            <SmallContentContainer>
                <Card padding="400">
                    <UpgradeContent />
                </Card>
            </SmallContentContainer>
        );
    }

    return <CheckInFieldsContainer enterpriseId={enterpriseId} />;
};
